module.exports = {
  hello_world: "Hellow World!",










}


//////////////////
// WEBPACK FOOTER
// ./lang/ch/messages.js
// module id = FUsx
// module chunks = 22